import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const TransctionLog = () => {
  const [logs] = useState([
    {
      id: 1,
      admin: "Superadmin",
      email: "superadmin@system.com",
      role: "Super Admin",
      action: "Remove",
      type: "Removed Points",

      date: "03-Sep-2025 10:30 AM",
      points: "40",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi molestias provident ea tempore sed odit voluptatum nihil architecto dolores saepe.",
    },
    {
      id: 2,
      admin: "John Admin",
      email: "john.admin@system.com",
      role: "Admin",
      action: "Add",
      type: "Added Points",

      date: "02-Sep-2025 05:15 PM",
      points: "40",
      reason: "--",
    },
  ]);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Admin/User</TableCell>
              <TableCell>User Detail</TableCell>
              <TableCell>Points Type</TableCell>
              <TableCell>Loyalty Points</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow hover key={log.id}>
                {/* Admin Info */}
                <TableCell>
                  <div className="user_block">
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="Images"
                      />
                    </figure>
                    <p>
                      <b>{log.admin}</b>
                      <span>{log.email}</span>
                      <span>Role: {log.role}</span>
                    </p>
                  </div>
                </TableCell>

                <TableCell>
                  <div className="user_block">
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="Images"
                      />
                    </figure>
                    <p>
                      <b>{log.admin}</b>
                      <span>{log.email}</span>
                      <span>9876543210</span>
                    </p>
                  </div>
                </TableCell>

                {/* Details */}
                <TableCell>{log.type}</TableCell>

                <TableCell>
                  <span
                    className={`status_btn ${
                      log.action === "Add"
                        ? "c_success"
                        : log.action === "Remove"
                        ? "c_danger"
                        : ""
                    }`}
                  >
                    {log.points}
                  </span>
                </TableCell>
                <TableCell className="max_c2"> <p>{log.reason}</p></TableCell>
                {/* Date */}
                <TableCell>{log.date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TransctionLog;
